import { Button } from '@curology/ui-components-web/react/Button';
import { useAtom } from 'jotai';
import React, { useCallback, useMemo, useState } from 'react';

import { FlashMessagesState } from '@/atoms/flashMessages/flashMessagesState';
import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { useNavigation } from '@/components/flow/hooks/useNavigation';
import { updateVisitOrder } from '@/services/visitsService/client';
import { useVisitContext } from '@/services/visitsService/hooks/useVisitContext';
import { type SwapUpsell } from '@/utils/shopify/types/swapUpsell';
import { trimId } from '@/utils/shopify/utils/ids';

const FooterCtas = ({ swapUpsell }: { swapUpsell: SwapUpsell }) => {
  const { brand } = useFlowContext();
  const { onNext } = useNavigation();
  const { visit } = useVisitContext();
  const order = useMemo(() => visit?.orders[0], [visit]);

  const [flashMessages, setFlashMessages] = useAtom(
    FlashMessagesState.flashMessagesAtom,
  );

  const [processing, setProcessing] = useState(false);

  const updateOrder = useCallback(async () => {
    if (!order || !visit) {
      return;
    }

    setProcessing(true);
    await updateVisitOrder({
      brand,
      uuid: visit.uuid,
      orderId: order.id,
      removeShopifyProductVariantId: trimId(swapUpsell.removeVariant.value),
      addShopifyProductVariantId: trimId(swapUpsell.addVariant.value),
    });

    setProcessing(false);
    onNext();
  }, [order]);

  if (!order) {
    return null;
  }

  return (
    <div className="cur-bg-surface-neutral cur-bottom-0 cur-left-0 cur-w-screen cur-fixed">
      <div className="cur-flex cur-max-w-[550px] cur-mx-auto cur-p-4">
        <div className="cur-flex-1">
          <div className="cur-pr-2">
            <Button
              buttonType="secondary"
              className="cur-w-full"
              disabled={processing}
              onClick={onNext}
            >
              Skip
            </Button>
          </div>
        </div>
        <div className="cur-flex-1">
          <div className="cur-pl-2">
            <Button
              className="cur-w-full"
              disabled={processing}
              onClick={updateOrder}
            >
              Upgrade for free
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterCtas;
